import { render } from "./ChangeRow.vue?vue&type=template&id=22a1e4a2&scoped=true"
import script from "./ChangeRow.vue?vue&type=script&lang=js"
export * from "./ChangeRow.vue?vue&type=script&lang=js"

import "./ChangeRow.vue?vue&type=style&index=0&id=22a1e4a2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22a1e4a2"]])

export default __exports__